module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/buy-prize_3-b401042f69dc37ae110e27a8d8e92ef7.png";